import { createSlice } from "@reduxjs/toolkit";
import { categories } from "common/data/jobLanding";
import {getBrandCategory, getBrandThunk, getSellerBrandThunk } from "./thunk";
import { getBrands } from "helpers/backend_helper";
export const initialState: any = {
  brands: [],
  sellerBrands: [],
  brandCategory:[],
  error: {},
  counts: 0
};

const BrandSlice = createSlice({
  name: 'BrandSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBrandThunk.fulfilled, (state: any, action: any) => {
      state.brands = action.payload.brands;
      state.counts = action.payload.counts;
    });

    builder.addCase(getBrandThunk.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getSellerBrandThunk.fulfilled, (state: any, action: any) => {
      state.sellerBrands = action.payload.sellerBrands;
      state.counts = action.payload.counts;
    });

    builder.addCase(getSellerBrandThunk.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getBrandCategory.fulfilled, (state: any, action: any) => {
      state.brandCategory = action.payload.brandCategory.data ||[];
      state.counts = action.payload.counts;
    });
  }
});



export default BrandSlice.reducer;